import * as React from 'react'

const SvgFilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 17.5h-2.5c-.69 0-1.25-.56-1.25-1.25v-4.744L2.869 6.875a1.25 1.25 0 01-.369-.881V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v2.244a1.25 1.25 0 01-.369.881L12.5 11.506v4.744c0 .69-.56 1.25-1.25 1.25zM3.75 3.75v2.244l5 5v5.256h2.5v-5.256l5-5V3.75H3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgFilterIcon
